import { importProvidersFrom, LOCALE_ID } from '@angular/core'

import { environment } from './environments/environment'
import { AppComponent } from './app/app.component'
import { OAuthModule } from 'angular-oauth2-oidc'
import { ToastrModule } from 'ngx-toastr'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { routes } from './app/app.routes'
import { provideAnimations } from '@angular/platform-browser/animations'
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser'
import { ErrorInterceptor } from './app/core/interceptors/error-interceptor'
import { AuthInterceptor } from './app/core/interceptors/auth-interceptor'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import {provideRouter, withComponentInputBinding} from '@angular/router'

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(
      BrowserModule,
      NgbModule,
      ToastrModule.forRoot(),
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.baseUrl],
          sendAccessToken: false,
        },
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'fr' },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err))
